'use strict';

var _ = require('lodash');
var FaresOptimizerDateChartController = function FaresOptimizerDateChartController($scope, dateChartTransformationService, FaresOptimizerConstants, $timeout) {
  $scope.$watchCollection('chartData', function (chartData) {
    if (_.get(chartData, 'data')) {
      var data = chartData.data;
      data.isAdaptiveMode = $scope.screenState.recommendMode === FaresOptimizerConstants.CATEGORY.ADAPTIVE;
      $scope.transformedData = _.isEmpty(data) ? data : dateChartTransformationService.transformData(data, chartData.title, chartData);
      $timeout(function () {
        return $scope.renderChart($scope.transformedData);
      }, 0);
    }
  });
};
FaresOptimizerDateChartController.$inject = ['$scope', 'FaresOptimizerDateChartTransformationService', 'FaresOptimizerConstants', '$timeout'];
module.exports = FaresOptimizerDateChartController;